var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L9.89029 1.46901C10.2497 1.19251 10.7503 1.19251 11.1097 1.46901L17 6",
    stroke: "black",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 21,
    height: 12,
    rx: 2,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57723 13.072C2.25123 13.072 1.27923 12.148 1.27923 10.9C1.27923 9.652 2.25123 8.728 3.57723 8.728C4.89723 8.728 5.87524 9.646 5.87524 10.9C5.87524 12.154 4.89723 13.072 3.57723 13.072ZM3.57723 12.244C4.32723 12.244 4.89123 11.698 4.89123 10.9C4.89123 10.102 4.32723 9.556 3.57723 9.556C2.82723 9.556 2.26323 10.102 2.26323 10.9C2.26323 11.698 2.82723 12.244 3.57723 12.244ZM8.30373 8.8C9.42573 8.8 10.1277 9.382 10.1277 10.324C10.1277 11.26 9.42573 11.842 8.30373 11.842H7.45773V13H6.48573V8.8H8.30373ZM8.24973 11.05C8.84373 11.05 9.14373 10.78 9.14373 10.324C9.14373 9.862 8.84373 9.592 8.24973 9.592H7.45773V11.05H8.24973ZM11.6677 12.22H13.9537V13H10.7017V8.8H13.8757V9.58H11.6677V10.492H13.6177V11.248H11.6677V12.22ZM17.4991 8.8H18.4591V13H17.6611L15.5671 10.45V13H14.6071V8.8H15.4111L17.4991 11.35V8.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon_open.9248ccea1e0d0c732432516048dc0780.svg";
export { ForwardRef as ReactComponent };